import { render, staticRenderFns } from "./EditNickName.vue?vue&type=template&id=419649c2&scoped=true&"
import script from "./EditNickName.vue?vue&type=script&lang=ts&"
export * from "./EditNickName.vue?vue&type=script&lang=ts&"
import style0 from "./EditNickName.vue?vue&type=style&index=0&id=419649c2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419649c2",
  null
  
)

export default component.exports